import detailMessage from './detailMessage';
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { verifyWorkerEmail } from "./api";
import ConfirmShell from "./components/ConfirmShell";
import { useLang } from "./LangContext";

interface VerifyData {
  e_mail: string;
}

type PageState =
  | { status: "loading" }
  | { status: "ok"; data: VerifyData }
  | { status: "error"; message: string };

export default function VerifyEmailPage() {
  const { t } = useLang();
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<PageState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    verifyWorkerEmail(token!)
      .then((data: VerifyData) => {
        if (cancelled) return;
        setState({ status: "ok", data });
      })
      .catch((err) => {
        if (cancelled) return;
        const detail = detailMessage(err, t.verificationFailed);
        setState({ status: "error", message: detail });
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <ConfirmShell>
      {state.status === "loading" && (
        <>
          <div className="confirm-spinner" aria-hidden="true" />
          <h2>{t.verifyingEmail}</h2>
        </>
      )}
      {state.status === "ok" && (
        <>
          <div className="confirm-status-icon ok" aria-hidden="true">✓</div>
          <h2>{t.emailVerifiedTitle}</h2>
          <p>{t.emailVerifiedMessage(state.data.e_mail)}</p>
          <p className="close-tab-hint">{t.closeTab}</p>
        </>
      )}
      {state.status === "error" && (
        <>
          <div className="confirm-status-icon error" aria-hidden="true">!</div>
          <h2>{t.somethingWentWrong}</h2>
          <p>{state.message}</p>
          <p className="close-tab-hint">{t.closeTab}</p>
        </>
      )}
    </ConfirmShell>
  );
}
